import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Contrato from "../pages/legal/Contrato";
import Terminos from "../pages/legal/Terminos";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/contrato",
    element: <Contrato />,
  },
  {
    path: "/terminos",
    element: <Terminos />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
